require('angular')
IndicatorDirective = require('./indicator-directive')

modules = []

angular.module 'gnp-animate', modules
  .directive 'gnpIndicator', IndicatorDirective



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/components/animate/animate-module.coffee